(function () {
  if (!document.body.classList.contains('template-product')) return;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      var format =
        (window.theme && window.theme.moneyFormat) ||
        (window.T4Sconfigs && T4Sconfigs.moneyFormat) ||
        '${{amount}}';
      return Shopify.formatMoney(cents, format);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function getVariantId(form) {
    var select = form.querySelector('[name="id"]');
    if (select && select.value) return select.value;

    var checked = form.querySelector('[name="id"]:checked');
    return checked ? checked.value : null;
  }

  function toggleSubscribeMessage(show) {
    document.querySelectorAll('.sbs_message').forEach(function (el) {
      el.style.display = show ? 'block' : 'none';
    });
  }

  function initSubscribe(root) {
    var form = root.closest('form[action*="/cart/add"]');
    if (!form) return;

    var jsonEl = root.querySelector('[data-rb-subscribe-json]');
    var data = null;

    try {
      data = JSON.parse(jsonEl.textContent);
    } catch (err) {
      return;
    }

    var planInput = root.querySelector('[data-rb-selling-plan]');
    var onetimePriceEl = root.querySelector('[data-rb-onetime-price]');
    var subscribePriceEl = root.querySelector('[data-rb-subscribe-price]');
    var discountEl = root.querySelector('[data-rb-subscribe-label]');
    var options = root.querySelectorAll('.rb-pdp-purchase__option');
    var radios = root.querySelectorAll('.rb-pdp-purchase__input');

    function setActiveOption(option) {
      options.forEach(function (el) {
        el.classList.toggle('is-active', el === option);
      });
    }

    function updatePrices(variantId) {
      var prices = data.variants[variantId];
      if (!prices) return;

      if (onetimePriceEl) onetimePriceEl.textContent = formatMoney(prices.onetime);
      if (subscribePriceEl) subscribePriceEl.textContent = formatMoney(prices.subscribe);

      if (discountEl && prices.onetime > prices.subscribe && prices.onetime > 0) {
        var pct = Math.round(((prices.onetime - prices.subscribe) * 100) / prices.onetime);
        discountEl.textContent = 'Subscribe, Save ' + (pct > 0 ? pct : 20) + '%';
      } else if (discountEl) {
        discountEl.textContent = 'Subscribe, Save 20%';
      }
    }

    function setPurchaseType(type) {
      var isSubscribe = type === 'subscribe';

      if (planInput) {
        if (isSubscribe) {
          planInput.disabled = false;
          planInput.value = data.defaultPlanId;
        } else {
          planInput.value = '';
          planInput.disabled = true;
        }
      }

      toggleSubscribeMessage(isSubscribe);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        setActiveOption(radio.closest('.rb-pdp-purchase__option'));
        setPurchaseType(radio.value);
      });
    });

    var variantField = form.querySelector('[name="id"]');
    if (variantField) {
      variantField.addEventListener('change', function () {
        updatePrices(getVariantId(form));
      });
    }

    document.addEventListener('change', function (event) {
      if (!form.contains(event.target)) return;
      if (event.target.matches('[data-swatch-item]')) {
        setTimeout(function () {
          updatePrices(getVariantId(form));
        }, 0);
      }
    });

    setPurchaseType('onetime');
    updatePrices(getVariantId(form));
  }

  document.querySelectorAll('[data-rb-subscribe]').forEach(initSubscribe);
})();
